import {
  TConditionTriggerStep,
  TTriggerStep,
  TUICondition,
  TUIEmptyCondition,
} from 'src/containers/Triggers/types';

type TTriggerNodeData = {
  step: TTriggerStep<TConditionTriggerStep<TUICondition | TUIEmptyCondition>>;
  ui: {
    isConditionSelected: boolean;
  };
};

const makeTriggerNodeData = (step: TTriggerNodeData['step']): TTriggerNodeData => ({
  step,
  ui: {
    isConditionSelected: false,
  },
});

export {TTriggerNodeData, makeTriggerNodeData};
